<template>
  <div class="live-lottery-setting">
    <div class="lottery-form">
      <vh-form :model="lotteryForm" :label-width="$i18n.locale == 'en' ? '100px' : '80px'">
        <vh-form-item :label="$t('host.k_566001')" required>
          <div class="vmp-lottery-img">
            <div :class="['vmp-lottery-img_gif', isChecked == 0 ? 'checkedBorder' : '']">
              <vh-upload
                class="vmp-lottery-img_upload"
                id="lottery_upload"
                :headers="headersVo"
                :action="action"
                :show-file-list="false"
                name="resfile"
                list-type="text"
                :before-upload="beforeUpload"
                :data="{
                  path: `${roomId}/img`,
                  type: 'image',
                  interact_token: interactToken
                }"
                accept=".jpg, .jpeg, .png, .bmp, .gif"
                :on-success="uploadSuccess"
              >
                <div v-if="lotteryForm.lotteryPicture">
                  <div class="lottery-picture" @click.stop.prevent="changeType(0)">
                    <img :src="lotteryForm.lotteryPicture" alt="" />
                  </div>
                  <div class="lottery-view">
                    <span @click.stop.prevent="changeImg">{{ $t('host.k_566002') }}</span>
                    <span @click.stop.prevent="deleteImg">{{ $t('host.k_566003') }}</span>
                  </div>
                </div>
                <div v-else class="lottery-icon">
                  <i class="vh-iconfont vh-a-line-cloudtoupload"></i>
                </div>
              </vh-upload>
              <span class="img-tangle" v-show="isChecked == 0">
                <img src="../../img/icon-choose.png" alt="" />
              </span>
            </div>
            <div
              :class="['vmp-lottery-img_gif', isChecked == 1 ? 'active' : '']"
              @click="changeType(1)"
            >
              <img src="../../img/prize01.png" alt="" />
              <span class="img-tangle" v-show="isChecked == 1">
                <img src="../../img/icon-choose.png" alt="" />
              </span>
            </div>
            <div
              :class="['vmp-lottery-img_gif', isChecked == 2 ? 'active' : '']"
              @click="changeType(2)"
            >
              <img src="../../img/prize02.png" alt="" />
              <span class="img-tangle" v-show="isChecked == 2">
                <img src="../../img/icon-choose.png" alt="" />
              </span>
            </div>
            <div
              :class="['vmp-lottery-img_gif', isChecked == 3 ? 'active' : '']"
              @click="changeType(3)"
            >
              <img src="../../img/prize03.png" alt="" />
              <span class="img-tangle" v-show="isChecked == 3">
                <img src="../../img/icon-choose.png" alt="" />
              </span>
            </div>
          </div>
          <p class="lottery_tip">{{ $t('host.k_566004') }}</p>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_566005')" required>
          <vh-input
            :maxlength="100"
            v-model="lotteryForm.title"
            :placeholder="$t('host.k_566006')"
            show-word-limit
            style="width: 390px"
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_566007')" required>
          <vh-input
            :maxlength="20"
            v-model="lotteryForm.description"
            :placeholder="$t('host.k_566008')"
            show-word-limit
            style="width: 390px"
          ></vh-input>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_566009')">
          <vh-radio-group v-model="lotteryForm.lottery_method" class="lottery_method">
            <vh-radio :label="0">{{ $t('host.k_566010') }}</vh-radio>
            <vh-radio :label="1">
              {{ $t('host.k_566011') }}
              <vh-input
                v-model="lotteryForm.lottery_countdown"
                maxlength="4"
                placeholder="1-9999"
                @input="inputCount"
              >
                <template slot="append">{{ $t('host.k_566012') }}</template>
              </vh-input>
              {{ $t('host.k_566013') }}
            </vh-radio>
          </vh-radio-group>
        </vh-form-item>
        <vh-form-item :label="$t('host.k_566014')">
          <p class="alertTxt">{{ $t('host.k_566015') }}</p>
          <vh-radio-group v-model="lotteryForm.display_of_results" class="position">
            <vh-radio :label="0">{{ $t('host.k_566016') }}</vh-radio>
            <vh-radio :label="1">{{ $t('host.k_566017') }}</vh-radio>
          </vh-radio-group>
        </vh-form-item>
      </vh-form>
      <div class="lottery-form_btn">
        <vh-button
          type="primary"
          :disabled="Boolean(!lotteryForm.title)"
          round
          @click="saveLotteryInfo"
          v-preventReClick
        >
          {{ $t('host.k_566018') }}
        </vh-button>
      </div>
    </div>
    <div class="lottery-preview">
      <div
        class="lottery-preview_mask"
        :class="lotteryForm.display_of_results == 1 ? 'partScreen' : ''"
      >
        <div class="lottery-preview_show" :style="`backgroundImage: url(${backgroundImg})`">
          <div :class="`lottery-preview_title lottery-title_0${isChecked}`">
            {{ lotteryForm.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { useRoomBaseServer, useLotteryServer } from 'middle-domain';
  import prize0 from '../../img/prize01.gif';
  import prize1 from '../../img/prize02.gif';
  import prize2 from '../../img/prize03.gif';
  export default {
    data() {
      return {
        lotteryForm: {
          title: '',
          description: this.$t('host.k_566008'),
          lotteryPicture: '',
          lottery_method: 0,
          lottery_countdown: '',
          display_of_results: 0
        },
        compulsory_award: 0,
        lottery_id: '',
        isChecked: 1,
        backgroundImg: '',
        prizeUrl: [prize0, prize1, prize2],
        action: `${process.env.VUE_APP_BASE_URL}/v3/commons/upload/index`
      };
    },
    computed: {
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.roomBaseServer.state.watchInitData.join_info.role_name;
      },
      lotteryId() {
        return this.lotteryServer.state.lotteryLiveId;
      },
      headersVo: function () {
        const vo = {
          // 助理&嘉宾端不传token
          token: this.roleName == 3 || this.roleName == 4 ? '' : this.headToken,
          platform: 7,
          'gray-id': this.grayId
        };
        return vo;
      }
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
      this.roomBaseServer = useRoomBaseServer();
    },
    created() {
      const { watchInitData } = useRoomBaseServer().state;
      this.roomId = watchInitData?.interact?.room_id;
      this.interactToken = watchInitData?.interact?.interact_token;
      this.headToken = sessionStorage.getItem('token');
      this.grayId = sessionStorage.getItem('initGrayId') || '';
      this.initComponent();
    },
    methods: {
      initComponent() {
        if (this.lotteryId) {
          this.lottery_id = this.lotteryId;
          this.getLiveLotteryInfo();
        } else {
          this.backgroundImg = this.prizeUrl[0];
        }
      },
      getLiveLotteryInfo() {
        this.lotteryServer.getLiveLotteryInfo(this.lotteryId).then(res => {
          if (res.code === 200 && res.data) {
            this.lotteryForm.description = res.data.description;
            this.lotteryForm.title = res.data.title;
            this.lotteryForm.lottery_method =
              (res.data.lottery_method && parseInt(res.data.lottery_method + '')) || 0;
            this.lotteryForm.lottery_countdown =
              (res.data.lottery_countdown && parseInt(res.data.lottery_countdown + '')) || '';
            this.lotteryForm.display_of_results =
              (res.data.display_of_results && parseInt(res.data.display_of_results + '')) || 0;
            this.localLottery = res.data;
            if (parseInt(res.data.img_order) > 0) {
              this.isChecked = parseInt(res.data.img_order);
              this.backgroundImg = this.prizeUrl[res.data.img_order - 1] || res.data.img_path;
            } else {
              this.isChecked = 0;
              this.backgroundImg = this.prizeUrl[res.data.img_order - 1] || res.data.img_path;
              this.lotteryForm.lotteryPicture = res.data.img_path;
            }
          }
        });
      },
      saveLotteryInfo() {
        if (this.lotteryForm.lottery_method == 1 && !this.lotteryForm.lottery_countdown) {
          this.$vhMessage({
            message: this.$t('host.k_566019'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return;
        }
        let imgUrl =
          parseInt(this.isChecked) > 0
            ? this.prizeUrl[this.isChecked - 1]
            : this.lotteryForm.lotteryPicture;
        let params = {
          title: this.lotteryForm.title,
          img_path: imgUrl,
          img_order: this.isChecked,
          description: this.lotteryForm.description,
          lottery_id: this.lottery_id || '',
          lottery_method: this.lotteryForm.lottery_method,
          display_of_results: this.lotteryForm.display_of_results
        };
        if (this.lotteryForm.lottery_method == 1) {
          params.lottery_countdown = this.lotteryForm.lottery_countdown;
        }
        this.lotteryServer
          .saveLiveLotteryInfo(params)
          .then(res => {
            if (res.code === 200) {
              // 创建成功之后，更新抽奖id
              this.lottery_id = res.data;
              this.lotteryServer.recordLotteryInfo(res.data);
              this.$message.success(this.$t('host.k_566020'));
              this.$emit('success', { type: 'lottery', act: 'save' });
              this.returnStep('edit');
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            console.log('err:', err);
            this.$message.error(err.msg);
          });
      },
      // 返回列表
      returnStep(name) {
        this.$emit('returnStep', name);
      },
      beforeUpload(file) {
        const typeList = ['jpg', 'png', 'jpeg', 'gif', 'bmp'];
        let typeArr = file.type.toLowerCase().split('/');
        const isType = typeList.includes(typeArr[typeArr.length - 1]);
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isType) {
          this.$message.warning(this.$t('host.k_566021'));
          return false;
        }
        if (!isLt2M) {
          this.$message.warning(this.$t('other.other_1004'));
          return false;
        }
        return isType && isLt2M;
      },
      uploadSuccess(res, file) {
        console.log(res, file);
        if (res.code === 200) {
          this.lotteryForm.lotteryPicture = res.data.domain_url;
          this.isChecked = 0;
          this.backgroundImg = res.data.domain_url;
        } else {
          this.$message.error(this.$tec(res.code), this.$t('host.k_566022'));
        }
      },
      changeImg() {
        let dom = document.querySelector('#lottery_upload .vh-upload__input');
        dom.click();
      },
      changeType(index) {
        this.isChecked = index;
        this.backgroundImg = this.prizeUrl[index - 1];
        if (!index) {
          this.backgroundImg = this.lotteryForm.lotteryPicture;
        }
      },
      deleteImg() {
        this.lotteryForm.lotteryPicture = '';
        this.backgroundImg = this.prizeUrl[0];
        if (this.isChecked == 0) {
          this.isChecked = 1;
        }
      },
      inputCount(value) {
        this.lotteryForm.lottery_countdown = value.replace(/[^\d]+/, '');
      }
    }
  };
</script>
<style lang="less">
  .live-lottery-setting {
    display: flex;
    display: flex;
    justify-content: space-between;
    position: relative;
    height: 500px;
    .lottery-form {
      width: 480px;
      padding-top: 10px;
      .vmp-lottery-img {
        display: flex;
        text-align: center;
        justify-content: space-between;
        &_gif {
          width: 88px;
          height: 88px;
          border-radius: 4px;
          border: 1px solid #ccc;
          background: #f7f7f7;
          position: relative;
          transition: all 0.15s ease-in;
          cursor: pointer;
          &:hover {
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
            .lottery-view {
              display: flex;
              justify-content: space-around;
              align-items: center;
              color: #fff;
            }
          }
          &.active {
            border: 1px solid #fb3a32;
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
          }
          &.checkedBorder {
            border: 1px solid #fb3a32;
            .vh-upload--picture-card {
              border: 0;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
          .lottery-picture {
            width: 88px;
            height: 88px;
            z-index: 10;
            img {
              width: 100%;
              height: 100%;
              object-fit: scale-down;
            }
          }
          .lottery-icon {
            margin-top: 22px;
            i {
              font-size: 32px;
            }
          }
          .img-tangle {
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            height: 20px;
            font-size: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .lottery-view {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            background: rgba(0, 0, 0, 0.7);
            border-radius: 2px 2px 0 0;
            display: none;
            span {
              font-size: 12px;
              display: inline-block;
              line-height: 26px;
              color: #fff;
            }
          }
        }
        &_upload {
          width: 88px;
          height: 88px;
          .vh-upload {
            width: 88px;
            height: 88px;
          }
        }
      }
      &_btn {
        width: 480px;
        padding-left: 80px;
      }
      .lottery_tip {
        color: #999;
        font-size: 12px;
        overflow-wrap: break-word;
        word-break: normal;
      }
      .lottery_method {
        display: flex;
        align-items: center;
        height: 40px;
        .vh-cascader-node > .vh-radio,
        .vh-radio:last-child {
          display: flex;
          align-items: center;
          .vh-radio__label {
            display: flex;
            align-items: center;
          }
          .vh-input-group__append {
            padding: 0 8px;
          }
        }
        .vh-input {
          width: 114px;
          margin: 0 8px;
        }
      }

      .alertTxt {
        overflow-wrap: break-word;
        word-break: normal;
      }
    }
    .lottery-preview {
      width: 280px;
      height: 503px;
      background-image: url('../../img/prize.png');
      background-size: cover;
      margin-top: -25px;
      position: relative;
      &_mask {
        position: absolute;
        top: 65px;
        left: 35px;
        width: 230px;
        height: 410px;
        background: rgba(#000, 0.7);
        border-radius: 0 0 24px 24px;
        &.partScreen {
          background: url('../../img/modal.png') top no-repeat;
          top: auto;
          width: 219px;
          left: 40px;
          bottom: 33px;
          height: 245px;
          background-size: cover;
          // border-radius: 0;

          .prize-show {
            margin-top: 0;
          }
        }
      }
      &_show {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0 auto;
        text-align: center;
        width: 150px;
        height: 170px;
        background-size: 100%;
        background-repeat: no-repeat;
        // margin-top: 16px;
        background-position: center;
      }
      &_title {
        position: absolute;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 12px;
        color: #fff;
        transform-origin: center left;
        &.lottery-title_00 {
          bottom: -10px;
          left: 2px;
          width: 150px;
          color: #d42e00;
        }
        &.lottery-title_01 {
          bottom: 14px;
          left: 48px;
          width: 90px;
          transform: scale(0.7);
        }
        &.lottery-title_02 {
          top: 14px;
          left: 27px;
          width: 118px;
          transform: scale(0.8);
        }
        &.lottery-title_03 {
          bottom: 49px;
          left: 55px;
          width: 75px;
          transform: scale(0.7);
        }
      }
    }
  }
</style>
